import { NgModule } from '@angular/core';
import { TelephonePipe } from './telephone/telephone.pipe';
import { PlaintextPipe } from './plaintext/plaintext.pipe';
import { FinderPipe } from './finder/finder.pipe';
import { GenericPipe } from './generic/generic.pipe';
import { MarkPipe } from './mark/mark.pipe';
import { FormatPipe } from './format/format.pipe';

@NgModule({
  declarations: [
    TelephonePipe,
    PlaintextPipe,
    FinderPipe,
    GenericPipe,
    MarkPipe,
    FormatPipe
  ],
  exports: [
    TelephonePipe,
    PlaintextPipe,
    FinderPipe,
    GenericPipe,
    MarkPipe,
    FormatPipe
  ]
})
export class SharedPipesModule {}
